import { type BackendModule, use } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { LANGUAGES } from '@/domains/shared/constants'
import enTranslations from '@/i18n/locales/en/translations.json'

// English stays in the entry chunk: it is the fallback and what the tests read.
// Serbian (about 31 KB gzipped) loads on demand, so a cold load and every
// post-deploy load fetch one language instead of two. A Serbian user sees the
// English fallback for the few milliseconds until the chunk lands, hidden by
// the hydration splash; every English key has a Serbian value (keyParity.test
// pins that), so nothing stays English once it has loaded.
const lazySerbian: BackendModule = {
  type: 'backend',
  init: () => undefined,
  read: (language, _namespace, callback) => {
    if (language !== LANGUAGES.Serbian) {
      callback(null, {})
      return
    }
    import('@/i18n/locales/sr/translations.json').then(
      (module) => callback(null, module.default),
      (error: unknown) => callback(error instanceof Error ? error : new Error(String(error)), null),
    )
  },
}

// `use` is i18next's plugin builder, not React 19's `use` hook - looks like a hook violation but isn't.
use(initReactI18next)
  .use(lazySerbian)
  .init({
    debug: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      [LANGUAGES.English]: { translation: enTranslations },
    },
    // Without this i18next assumes every language is in `resources` and never asks the backend.
    partialBundledLanguages: true,
    react: {
      useSuspense: false,
    },
    fallbackLng: LANGUAGES.English,
  })
